<template>
  <div>
    <vx-card v-show="isCardActiveLocal" class="contentCards" vs-align="center" :style="{ height: cardHeight + 'px', width: cardWidth + 'px', position: 'relative'}">
      <div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2" style="text-align: center;">
            <h3>Looks like you have <strong>already</strong> completed this quiz once before.</h3>
          </div>
        </div>
        <div class="vx-row mt-10">
          <div class="vx-col w-full mb-2" style="text-align: center;">
            <h5>Please wait while your results are retrieved...</h5>
            <vs-progress indeterminate color="success"></vs-progress>
          </div>
        </div>
      </div>
      <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
    </vx-card>

    <vs-popup title="Having some problems?" :active.sync="helpPopupActive">
      <p class="pb-2">Please tell us about the issues you are experiencing:</p>
      <vs-textarea v-model="errorData.userMessage" />
      <p class="pb-2">Your WhatsApp number:</p>
      <vs-input autocomplete="off" v-validate="'digits:10'" name="WhatsApp number" v-model="errorData.whatsappNumber" />
      <span class="text-danger text-sm" v-show="errors.has('WhatsApp number')">{{ errors.first('WhatsApp number') }}</span>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="submitIssue">Submit</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      cardHeight: {
        type: Number,
        required: false,
      },
      cardWidth: {
        type: Number,
        required: false,
      },
      errorDataProp: {
        type: Object,
        required: false
      },
      taskIdProp: {
        type: Number,
        required: false,
      },
    },
    data() {
      return {
        helpPopupActive: false,
        errorData: {
          userId: null,
          taskId: null,
          userMessage: "",
          osName: "",
          osVersion: "",
          browserName: "",
          browserVersion: "",
          navigatorUserAgent: "",
          navigatorAppVersion: "",
          navigatorPlatform: "",
          navigatorVendor: "",
          isMobile: false,
          whatsappNumber: ""
        }
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;

          
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) { }
      },
    },
    methods: {
      submitIssue() {
        var self = this;
        self.helpPopupActive = false;

        self.errorData.osName = self.errorDataProp.osName;
        self.errorData.osVersion = self.errorDataProp.osVersion;
        self.errorData.browserName = self.errorDataProp.browserName;
        self.errorData.browserVersion = self.errorDataProp.browserVersion;
        self.errorData.navigatorUserAgent = self.errorDataProp.navigatorUserAgent;
        self.errorData.navigatorAppVersion = self.errorDataProp.navigatorAppVersion;
        self.errorData.navigatorPlatform = self.errorDataProp.navigatorPlatform;
        self.errorData.navigatorVendor = self.errorDataProp.navigatorVendor;

        self.errorData.taskId = self.taskIdProp;
        self.errorData.isMobile = self.isMobile();
        
        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Issue submitted!",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });
        };

        self.$ajaxPost(self, "Student/LogError", self.errorData, onSuccess);
      }
    }
  };
</script>

<style lang="scss">
  .contentCards {
    margin: auto;
  }
</style>
